import { Component, Input } from '@angular/core';
import { Variable } from '../../model/variable/variable';
import { VariableValue } from '../../model/variable/variable-value';
import { ComponentVariable } from '../component-variable';


/*const HTML_TEMPLATE = `
<span class="var-title">{{variable.description}}</span>
<span class="var-optional" *ngIf="variable.optional">({{'COMMON.OPTIONAL' | tTranslate}})</span>
<ion-item no-lines no-padding>
    <ion-textarea autosize [maxlength]="variable.maxValue" [minlength]="variable.maxValue" [(ngModel)]="variableValue.value" 
        autocomplete="on" autocorrect="on" rows="1" (ionChange)="onChangeCallback()"></ion-textarea>
</ion-item>
`; */

const HTML_TEMPLATE = `
<span class="var-title">{{variable.description}}</span>
<span class="var-optional" *ngIf="variable.optional">({{'COMMON.OPTIONAL' | tTranslate}})</span>
<ion-item no-lines no-padding>

  <ion-input type="{{variable.type}}" placeholder="{{variable.placeholder}}" *ngIf="variable.type != 'text' && variable.type != 'number'"
    (ionChange)="onChangeCallback()" [(ngModel)]="variableValue.value"></ion-input>

  <ion-input type="{{variable.type}}" placeholder="{{variable.placeholder}}" *ngIf="variable.type == 'number'"
    (ionChange)="onChangeCallback()" [(ngModel)]="variableValue.value" [min]="variable.minValue" [max]="variable.maxValue"></ion-input>

  <ion-textarea autosize [maxlength]="variable.maxValue" [minlength]="variable.maxValue" [(ngModel)]="variableValue.value"
    autocomplete="on" autocorrect="on" rows="1" (ionChange)="onChangeCallback()" *ngIf="variable.type == 'text'"></ion-textarea>
</ion-item>
`;

const CSS_STYLE = `
.var-value-label {
    min-height: 59px;
}
`;

@Component({
    selector: 'variable-input',
    template: HTML_TEMPLATE,
    styles: [CSS_STYLE]
})
export class VariableInputComponent extends ComponentVariable {

    @Input('variable') variable: Variable;
    @Input('callbackOnChange') callback: Function;
    variableValue: VariableValue;

    constructor() {
        super();

        this.variableValue = {
            asBoolean: false,
            asString: "",
            value: ""
        }
    }

    ngOnInit() {
        this.setValue(this.variable.defaultValue);
        this.onChangeCallback();
    }

    getValue() {
        return this.variableValue;
    }

    setValue(variableValue: VariableValue): void {

        if (variableValue) {
            this.variableValue = {
                asBoolean: (variableValue.value ? true : false),
                asString: variableValue.value,
                value: variableValue.value
            }
        }
    }

    getVariable(): Variable {
        return this.variable;
    }

    onChangeCallback(): void {
        this.setValue(this.variableValue);

        this.callback(this);
    }

}
